import React from 'react';
import { Gauge, Target, TrendingUp } from 'lucide-react';

const snapshotIcons = {
  scale: TrendingUp,
  speed: Gauge,
  quality: Target,
};

export default function CaseStudyChallenge({ study }) {
  const chips = study.challenge?.chips || study.painPoints || [];
  const snapshot = study.challenge?.snapshot || [];

  return (
    <section className="cs-reveal relative overflow-hidden border-b border-border">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div
          className="absolute inset-0 opacity-60"
          style={{
            backgroundImage:
              'linear-gradient(to right, hsl(158 40% 72% / 0.05) 1px, transparent 1px), linear-gradient(to bottom, hsl(158 40% 72% / 0.05) 1px, transparent 1px)',
            backgroundSize: '56px 56px',
          }}
        />
        <svg className="absolute -right-10 top-0 h-full w-[46%] text-primary" viewBox="0 0 480 420" fill="none">
          <path d="M20 400C150 320 190 180 460 30" stroke="currentColor" strokeOpacity="0.16" />
          <path d="M70 420C210 330 250 160 480 90" stroke="currentColor" strokeOpacity="0.1" />
        </svg>
      </div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-start gap-8 px-4 py-10 sm:px-6 sm:py-12 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] lg:gap-12 lg:px-8 lg:py-14">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wider text-primary">The challenge</p>
          <h2 className="mt-3 max-w-xl text-xl font-normal leading-tight tracking-tight text-foreground sm:text-2xl">
            {study.challenge.title}
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-muted-foreground">
            {study.challenge.body}
          </p>
          {chips.length > 0 ? (
            <ul className="mt-6 flex flex-wrap gap-2">
              {chips.map((chip) => (
                <li key={chip} className="rounded-full border border-primary/25 px-3 py-1 text-xs font-semibold text-primary">
                  {chip}
                </li>
              ))}
            </ul>
          ) : null}
        </div>

        {snapshot.length > 0 ? (
          <aside className="min-w-0 self-start rounded-xl border border-primary/20 bg-card p-5 shadow-sm sm:p-6">
            <h3 className="text-sm font-semibold text-foreground">Challenge Snapshot</h3>
            <ul className="mt-3 divide-y divide-white/10">
              {snapshot.map((item) => {
                const Icon = snapshotIcons[item.icon] || Target;
                return (
                  <li key={item.label} className="flex items-center gap-3 py-3.5">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-primary/25 text-primary">
                      <Icon className="h-4 w-4" aria-hidden="true" />
                    </span>
                    <div className="min-w-0">
                      <p className="text-xs font-semibold uppercase tracking-wider text-primary">{item.label}</p>
                      <p className="mt-0.5 text-sm font-medium leading-snug text-foreground">{item.body}</p>
                    </div>
                  </li>
                );
              })}
            </ul>
          </aside>
        ) : null}
      </div>
    </section>
  );
}
